/*
 * Shared chrome for floating menus. Geometry, scrolling limits, and motion
 * remain component-owned because they depend on each anchor primitive.
 */
.menu {
  z-index: var(--layer-menu);
  border: 2px solid var(--glass-border);
  background:
    linear-gradient(
      145deg,
      var(--floating-surface-highlight, var(--glass-highlight)),
      rgba(124, 196, 255, 0.03)
    ),
    var(--glass-fill-strong);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  box-shadow: var(--glass-shadow);
}

/* Select and combobox panels share the same clipped, scroll-hosting shell. */
.listboxPanel {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  overflow: hidden;
  padding: var(--space-1);
  border-radius: var(--radius-md);
}

.listboxItem {
  width: 100%;
  min-height: 1.875rem;
  align-items: center;
  gap: var(--space-2);
  padding-inline: var(--space-2);
  border-radius: var(--radius-xs);
  color: var(--color-fg);
  cursor: default;
  outline: none;
}

.listboxItem[data-highlighted],
.listboxItem[data-selected] {
  background: var(--color-accent-soft);
}
